export default "__VITE_ASSET__08378e49__"